module.exports = __webpack_public_path__ + "static/media/example.b45e627c.jpg";